import { render, staticRenderFns } from "./DashboardWelcomeWidget.vue?vue&type=template&id=21dca0f0"
import script from "./DashboardWelcomeWidget.vue?vue&type=script&lang=js"
export * from "./DashboardWelcomeWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports